import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Constantes from "../../constantes";

function Registro() {
    const navigate = useNavigate();
    const [user_name, setUser_Name] = useState('');
    const [email, setEmail] = useState('');
    const [passw, setPassw] = useState('');
    const [publico, setPublico] = useState(false);
    const [term_cond, setTerm_cond] = useState(false);

    const [imagen_perfil, setImagenes] = useState(null);
    const [imagen_subida, setImagen_subida]= useState(Boolean);

    const handleImagenPerfil =(e) =>{
        const file = e.target.files[0];
        if(file){
            setImagenes(file);
            setImagen_subida(true);
        }
    }
    
    const handleEliminarImagen =() => {
        setImagenes(null);
        setImagen_subida(false);
    };

    const procesarPeticion = async (e) => {
        e.preventDefault()
        try {
            if (term_cond === true) {
                const formData = new FormData()
                formData.append("nombre", user_name)
                formData.append("email", email)
                formData.append("publico", publico)
                formData.append("password", passw)
                formData.append("file", imagen_perfil) // nombre del campo esperado por Multer

                const respuesta = await fetch(Constantes.RUTA_API + '/usuarios/registrar', {
                    method: 'POST',
                    body: formData
                })

                const data = await respuesta.json();
                
                if (!data.error) {
                    // Mostrar alert con mensaje de éxito y redireccionar
                    alert(`${data.message}\n\n⚠️ IMPORTANTE: Debes verificar tu cuenta antes de poder iniciar sesión. Revisa tu correo electrónico para el enlace de verificación.`);
                    navigate('/login');
                } else {
                    alert(data.message);
                }
            }
        } catch (error) { 
            console.error('Error al enviar:', error);
            alert('Hubo un error al enviar el formulario');
        }
    }

    return (
        <>
            <div className="App d-flex justify-content-center bg-dark text-white">

                <form onSubmit={procesarPeticion}>
                    <div class="mb-4 mt-4">
                    <input type="file" className="form-control" accept="image/*" id="imagen" name="imagen" onChange={handleImagenPerfil} style={{ display: "none" }} disabled={imagen_subida}/>
                            <label htmlFor="imagen" className="btn btn-outline-light">Seleccionar imagen de perfil</label>
                            {imagen_perfil && imagen_subida && (
                                <div className="mt-3 d-flex flex-wrap gap-3">
                                    
                                        <div
                                            className="position-relative border rounded p-2"
                                            style={{ width: "120px", height: "120px", overflow: "hidden" }}
                                        >
                                            <img
                                                src={URL.createObjectURL(imagen_perfil)}
                                                alt="imagen"
                                                className="img-fluid rounded"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-danger position-absolute rounded-circle"
                                                style={{ top: "5px", right: "5px" }}
                                                onClick={() => handleEliminarImagen()}
                                            >
                                                ✕
                                            </button>
                                        </div>
                                    
                                </div>
                            )}
                    </div>
                    <div class="mb-4 mt-4">
                        <label for="nombre_usuario" class="form-label">Nombre de usuario:</label>
                        <input value={user_name} onChange={(e) => setUser_Name(e.target.value)} type="nombre_usuario" class="form-control" id="user_name" placeholder="Yournini Trotamundos 🌐" name="user_name" />
                    </div>
                    <div class="mb-4 mt-4">
                        <label for="email" class="form-label">Email:</label>
                        <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" class="form-control" id="email" placeholder="yourny.oficial@gmail.com 📧" name="email" />
                    </div>
                    <div class="mb-4 mt-4">
                        <label for="password" class="form-label">Contraseña:</label>
                        <input value={passw} onChange={(e) => setPassw(e.target.value)} type="password" class="form-control" id="password" placeholder="Tu Contraseña *" name="password" />
                    </div>
                    <div class="form-check mb-4 mt-4">
                        <label class="form-check-label">
                            <input value={publico} onChange={(e) => setPublico(e.target.checked)} class="form-check-input" type="checkbox" name="publico" /> ¿Será una cuenta pública?🕵🏻‍♀️🕵🏻‍♂️
                        </label>
                        <p><strong>(Esto se puede cambiar después en configuración)</strong> ⚙</p>
                    </div>
                    <div class="form-check mt-4">
                        <label class="form-check-label">
                            <input value={term_cond} onChange={(e) => setTerm_cond(e.target.checked)} class="form-check-input" type="checkbox" name="term_cond" required /> Acepto los <a href="./TyC">terminos y condiciones</a> de Yourny 📃
                        </label>

                    </div>
                    <button type="submit" class="my-4 btn btn-primary" style={{width:"100%"}}>Completar registro</button>
                </form>
            </div>

            <title>Registro</title>
        </>
    );
}

export default Registro;